import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import OpenSansRegularEot from 'common-tridium/fonts/open-sans/OpenSans.eot';
import OpenSansRegularTtf from 'common-tridium/fonts/open-sans/OpenSans.ttf';
import OpenSansRegularSvg from 'common-tridium/fonts/open-sans/OpenSans.svg';
import OpenSansRegularWoff2 from 'common-tridium/fonts/open-sans/OpenSans.woff2';
import OpenSansRegularWoff from 'common-tridium/fonts/open-sans/OpenSans.woff';

import OpenSansBoldEot from 'common-tridium/fonts/open-sans/OpenSans-Bold.eot';
import OpenSansBoldTtf from 'common-tridium/fonts/open-sans/OpenSans-Bold.ttf';
import OpenSansBoldSvg from 'common-tridium/fonts/open-sans/OpenSans-Bold.svg';
import OpenSansBoldWoff2 from 'common-tridium/fonts/open-sans/OpenSans-Bold.woff2';
import OpenSansBoldWoff from 'common-tridium/fonts/open-sans/OpenSans-Bold.woff';

export const openSansRegular = {
  fontFamily: 'OpenSansRegular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: [
    'local("ToyotaDisplay")',
    'local("ToyotaDisplay-Regular")',
    `url(${OpenSansRegularEot}) format('embedded-opentype')`,
    `url(${OpenSansRegularWoff}) format('woff')`,
    `url(${OpenSansRegularWoff2}) format('woff2')`,
    `url(${OpenSansRegularTtf}) format('truetype')`,
    `url(${OpenSansRegularSvg}) format('svg')`,
  ].join(', '),
};

export const openSansBold = {
  fontFamily: 'OpenSansBold',
  fontStyle: 'normal',
  fontWeight: 700,
  src: [
    'local("OpenSans")',
    'local("OpenSans-Bold")',
    `url(${OpenSansBoldEot}) format('embedded-opentype')`,
    `url(${OpenSansBoldWoff}) format('woff')`,
    `url(${OpenSansBoldWoff2}) format('woff2')`,
    `url(${OpenSansBoldTtf}) format('truetype')`,
    `url(${OpenSansBoldSvg}) format('svg')`,
  ].join(', '),
};

export const useStyles = makeStyles<{ theme: Theme }>()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    textAlign: 'center',
  },
  layout: {
    backgroundColor: theme.palette.background.default,
    margin: `0 auto ${theme.spacing(5)}`,
  },
  lexusLayout: {
    backgroundColor: theme.palette.background.default,
    margin: `0 auto 0`,
  },
  lexusHeaderLayout: {
    backgroundColor: '#383838',
    margin: `0 auto ${theme.spacing(5.25)}`,
  },
  leasingFiltersLayout: {
    backgroundColor: theme.palette.background.default,
    margin: `0 auto ${theme.spacing(5)}`,
    maxWidth: '557px',
  },
}));
